<template>
  <layout-content><document-list /></layout-content>
</template>

<script>
  import DocumentList from '@core/components/documents/documents-table';

  export default {
    components: { DocumentList }
  };
</script>
